// extracted by mini-css-extract-plugin
export var readonly = "_hb-1";
export var star = "_hb-0";